import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.svg';
import Theme from 'theme';
import CustomTheme from 'customTheme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
  // SYNC-1090: parent origins allowed to receive booking events from the
  // embedded scheduler. Comma-separated exact origins; unset => feature off.
  REACT_APP_PARENT_EVENT_ORIGINS: parentEventOrigins,
} = process.env;

const locations = [
  { key: 'LOC1', name: 'Manor' },
  { key: 'LOC2', name: 'McKinney' },
  { key: 'LOC3', name: 'Saltillo' },
  { key: 'LOC4', name: 'The Domain' },
  { key: 'LOC5', name: 'The Grove' },
  { key: 'LOC6', name: 'Lantana Place' },
  { key: 'LOC7', name: 'Parmer Park' },
  { key: 'LOC8', name: 'South Lamar' },
];

const locationApptLinks = locations.map((loc) => {
  const { [`REACT_APP_${loc.key}_APPT_LINK`]: locApptLink } = process.env;
  return {
    name: loc.name,
    link: locApptLink,
    target: '_blank',
  };
});

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  parentEventOrigins,
  logoRedirectLink: 'https://enameldentistry.com/',
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Enamel Dentistry',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'dental',
  tokenName: 'enamelSubscriberToken',
  globalClass: 'enamel-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  enableBookAppointment: true,
  headerProps: {
    enable: false,
  },
  localeProps: {
    enable: true,
    localesList: [
      {
        key: 'en',
        value: 'English',
      },
      {
        key: 'es',
        value: 'Spanish',
      },
    ],
  },
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        to: '/find-a-provider',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-img.webp',
    },
    benefitsSection: {
      variant: 2,
      columns: 4,
      subtitleVariant: 'body1',
      subTitleColor: 'textSecondary',
      primaryButton: 'Sign up',
    },
    subscriptionSection: {
      tabVariant: 2,
      renderAsTabsLimit: 4,
      carouselResponsiveItems: {
        desktop: 3,
      },
      primaryButtonProps: {
        color: 'primary',
      },
      loaderColor: 'primary',
    },
    howItWorksSection: {
      variant: 1,
      alignTitle: 'left',
      heroImage: '/images/home-images/how-it-works.webp',
      primaryButtonProps: {
        variant: 'contained',
        color: 'Primary',
      },
    },
    testimonialSection: {
      variant: 2,
      centerMode: true,
      avatarStyle: 'top',
      subtitleVariant: 'body1',
      sectionClass: 'section-container',
      messageType: 'h6',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      titleProps: { color: 'primary' },
      subtitleProps: { color: 'primary' },
    },
  },
  findProviderSection: {
    iconProps: {
      url: '/images/appointment/map-loc-icon.svg',
      infoUrl: '/images/appointment/map-loc-info-icon.svg',
    },
  },
  choosePlanSection: {
    locationLogo: Logo,
    cardVariant: 2,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      titleProps: { color: 'primary' },
      subtitleProps: { color: 'primary' },
    },
  },
  checkoutSection: {
    addon: {
      color: 'primary',
      iconColor: 'primary',
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
    bookAppointmentProps: {
      link: bookAppointmentLink,
      target: '_blank',
      locationList: locationApptLinks,
    },
  },
  savingsSummary: {},
  dashboardProps: {
    showBenefitsUsage: true,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointmentV2: {
    theme: CustomTheme,
    rightImage: '/images/appointment/right-image.webp',
    skipPatientTypeSelection: true,
    flowV2: true,
    parentEventOrigins,
    enableVerifyInsurance: false,
    disableRegionGrouping: true,
    enableDiscoverDiscount: false,
    enableAdditionalComments: true,
  },
  footer: {
    enable: false,
  },
  loginPage: {
    bannerImage: './images/login.webp',
  },
  theme: Theme,
  surveyForms: {
    enabled: true,
    theme: CustomTheme,
  },
};

export default config;
